export default __webpack_public_path__ + "static/media/math-multipart-combination-blue.3a483830.svg";